export default {
  // Perfil
  profile_title: 'Perfil de Usuario',
  personal_info: 'Información Personal',
  preferences: 'Preferencias',
  recent_activity: 'Actividad Reciente',
  help_center: 'Centro de Ayuda',
  full_name: 'Nombre Completo',
  email: 'Correo Electrónico',
  phone: 'Teléfono',
  role: 'Rol',
  status: 'Estado',
  save_changes: 'Guardar Cambios',
  saving: 'Guardando...',
  change_password: 'Cambiar Contraseña',
  manage_users: 'Gestionar Usuarios',
  email_cannot_change: 'El correo no se puede modificar',
  role_assigned_by_admin: 'El rol es asignado por el administrador',

  // Preferencias
  notifications: 'Notificaciones',
  email_notifications: 'Notificaciones por correo',
  email_notifications_desc: 'Recibir actualizaciones importantes por email',
  task_reminders: 'Recordatorios de tareas',
  task_reminders_desc: 'Alertas cuando se acercan fechas límite',
  weekly_reports: 'Reportes semanales',
  weekly_reports_desc: 'Resumen semanal de actividades y progreso',
  appearance: 'Apariencia',
  language: 'Idioma',
  theme: 'Tema',
  theme_light: 'Claro',
  theme_dark: 'Oscuro',
  theme_auto: 'Automático',
  spanish: 'Español',
  english: 'English',
  save_preferences: 'Guardar Preferencias',

  // Contraseña
  current_password: 'Contraseña Actual',
  new_password: 'Nueva Contraseña',
  confirm_new_password: 'Confirmar Nueva Contraseña',
  password_min_chars: 'Mínimo 6 caracteres',
  cancel: 'Cancelar',
  change: 'Cambiar',
  password_success: 'Cambios guardados exitosamente',
  password_error_match: 'Las contraseñas no coinciden',
  password_error_length: 'La contraseña debe tener al menos 6 caracteres',

  // Actividad
  login_success: 'Inicio de sesión exitoso',
  hours_ago: 'Hace {{count}} horas',
  day_ago: 'Hace 1 día',
  days_ago: 'Hace {{count}} días',

  // Dashboard / Home
  dashboard: 'Inicio',
  processes: 'Procesos',
  dependencies: 'Dependencias',
  tasks: 'Tareas',
  evidences: 'Evidencias',
  tracking: 'Seguimiento y Evaluación',
  reports: 'Reportes',
  ranking: 'Ranking',
  users: 'Usuarios',
  logout: 'Cerrar Sesión',
  search: 'Buscar',
};